<script lang="ts" context="module">
  import { z } from "zod";
  export const contactCaptureSchema = z.object({
    uid: z.string(),
    email: z.string().email(),
    displayName: z
      .string({
        required_error: "Full name is required",
        invalid_type_error: "Full name must be a string",
      })
      .regex(/^[a-zA-Z\u00C0-\u017F\-\',\s]+$/, {
        message: "Full name must contain only letters and spaces",
      })
      .max(50, { message: "Must be 50 or fewer characters long" })
      .min(5, { message: "Must be 5 or more characters long" }),
    phone: z.string({
        required_error: "Phone is required"
      })
      .regex(/^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g, {
        message: "Must be a valid phone number",
      })
      .min(10, { message: "Phone number must be 10 or more characters long" }),
    preferredBootcamp: z.object({id: z.string(), title: z.string()})
      .refine((val) => val.id !== '', { message: "Please select a bootcamp" }),
    preferredCommunity: z.string().min(4, { message: "Must be 4 or more characters long" }),
    acceptTerms: z.boolean({
      required_error: "Accepting the terms is required",
    }).refine((val) => val === true, { message: "Accepting the terms is required" } ).default(true),
  });
  export type ContactCaptureSchema = typeof contactCaptureSchema;
</script>